import { useEffect, useState } from 'react';
import { FormikHelpers } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { Subtitle, MaskedInput, Form, Button, ArrowRight } from '~components';
import { useRequest } from 'ahooks';
import { useLayout } from '~hooks';
import validationSchema from './validation';
import { onlyNumbers } from '~constants/regularExpressions';
import { Loading } from './sections';
import * as Styled from './styled';
import { Values, OnboardingLocationState } from './types';
import { ChecklistAccess } from '~services';
import { SendSMSAccessChecklist } from '~services/types';

function ScreenCPF() {
  const { setLayout } = useLayout();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as OnboardingLocationState;
  const [cnpj, setCnpj] = useState<string>();

  const { runAsync: sendSMS, loading } = useRequest(ChecklistAccess.sms, {
    manual: true,
  });

  const initialValues = {
    cpf: '',
  };

  const handleSubmit = async (
    values: Values,
    helpers: FormikHelpers<Values>
  ) => {
    try {
      const cpfWithoutMask = values.cpf.replace(onlyNumbers, '');

      const data: SendSMSAccessChecklist = { cnpj, cpf: cpfWithoutMask };
      await sendSMS(data);

      navigate(`/entrar/token`, { state: { cnpj, cpf: cpfWithoutMask } });
      helpers.resetForm();
    } catch (error) {
      helpers.setFieldError('cpf', 'CPF não encontrado');
    }
  };

  useEffect(() => {
    if (locationState?.cnpj) {
      setCnpj(locationState.cnpj);
      return;
    }

    navigate('/');
  }, []);

  useEffect(() => {
    setLayout({ header: { position: 'left' } });
  }, [setLayout]);

  return (
    <Form<Values>
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      aria-labelledby="form-cpf-title"
      validateOnBlur={false}
      enableReinitialize
    >
      {({ isValid }) => {
        return (
          <>
            <Styled.Title id="form-cpf-title">Continuar processo</Styled.Title>
            <Subtitle>
              Para a sua segurança, informe seu CPF para que possamos enviar um
              código token para o seu celular via SMS.
            </Subtitle>
            <MaskedInput
              mask="999.999.999-99"
              name="cpf"
              label="Seu CPF *"
              type="tel"
              width="300px"
              placeholder="Digite seu CPF"
              trailingIcon={
                <Button
                  type="submit"
                  variant="icon"
                  disabled={!isValid}
                  aria-label="Prosseguir"
                >
                  <ArrowRight />
                </Button>
              }
            />
            <Loading visible={loading} />
          </>
        );
      }}
    </Form>
  );
}

export default ScreenCPF;
